import { ContractPricing, ContractPricingBody } from '@/services/requests/users/Users.types';

export const orderByType = (items: ContractPricingBody[]) => items.reduce<ContractPricing>(
  (acc, item) => {
    if (item.type === 'TRANSACTION' && !['SEPA', 'FSP', 'FPS', 'SWIFT'].some((payer) => item.code?.startsWith(payer))) {
      return acc;
    }
    return item.type === 'SUBSCRIPTION' ? [item, ...acc] : acc.concat(item);
  },
  [{
    name: 'Onboarding fee',
    issuers: [],
    type: 'TRANSACTION',
  }],
);
